import { Decoder, field, succeed } from 'jsonous';
import { resourceDecoder } from '../../../../../../Resource/Decoders';

import { stringOptionsContentDecoder } from '../../../../../GenericSortFilter/Decoders';
import { InvitationsOptions, InvitationsOptionsResource } from './Types';

const invitationsOptionsDecoder: Decoder<InvitationsOptions> = succeed({})
  .assign('invitationStatus', field('invitation_status', stringOptionsContentDecoder))
  .assign('invitationType', field('invitation_type', stringOptionsContentDecoder))
  .assign('userGroups', field('user_groups', stringOptionsContentDecoder))
  .assign('accessStatus', field('access_status', stringOptionsContentDecoder))
  .assign('sendDate', field('send_date', stringOptionsContentDecoder));

export const invitationsOptionsResourceDecoder: Decoder<InvitationsOptionsResource> =
  resourceDecoder(invitationsOptionsDecoder);
